<template lang="pug">

  transition(
    v-on:enter="enter"
    v-on:leave="leave"
    appear
    )

    #rating-four.content-section

      article.content-inner

        h1 How does a 4-star car crash?

        p A 4-star vehicle will give you and your passengers a reasonable chance of walking away after a crash without serious injury.
        
        p To be specific, 
          strong you’re 90% as likely to be protected 
          | as you would be in a 5-star car. The biggest difference is in the protection to arms and legs, with the brake pedals and steering wheel more likely to be forced into your 
          em survival bubble 
          | with the impact of the crash.
        
        h3 Next time you are buying, look for the highest star rating in your price range.

</template>

<script>

import { PATHS } from 'src/config/app'
import BaseContentPageMixin from '@/components/content-pages/mixins/BaseContentPage'

export default {

  name: PATHS.RATING_FOUR,

  mixins: [
    BaseContentPageMixin
  ],

  components: { },

  data() {
    return { }
  },

  computed: {},

  mounted() {},

  beforeDestroy() {},

  methods: {

  },

  watch: {},

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

</style>
